// MACHINERY V2 (Stroje) — kebab action set + permission gating (M2.2).
//
// Spec: MACHINERY_V2_IMPLEMENTATION_TICKET.md §10 + data package §9 "Actions".
//
// ONE PLACE decides which rows a given user sees on a given machine, so the
// gate cannot drift between the card, a future row (M2.3) and the profile
// (M2.4). No NEW gate is introduced: `canWrite` is `usePermission("Machinery")`
// .canWrite, the same level the live grid's PermissionGuard checks.
//
//   Read  (Workers included) : Profil · QR kód · Vytvoriť servisnú správu
//   Write                    : Vytvoriť servisnú žiadosť · Upraviť detaily ·
//                              Duplikovať · Priradiť do skupiny · Vyradiť ·
//                              Obnoviť
//
// QR IS VISIBLE TO EVERYONE, including on a decommissioned machine (§10: "QR
// code — always visible, incl. decommissioned"). A decommissioned machine
// collapses to QR + Obnoviť, which is the live grid's rule.
//
// No Tailwind, no shadcn, no MUI, no @emotion, no sx, no dt tokens.
import { Machine } from "../../models/models";
import { FleetMenuAction } from "./FleetCardMenu";

export interface FleetActionHandlers {
  onProfile: (m: Machine) => void;
  onQrCode: (m: Machine) => void;
  onCreateServiceReport: (m: Machine) => void;
  onCreateServiceRequest: (m: Machine) => void;
  onEditDetails: (m: Machine) => void;
  onDuplicate: (m: Machine) => void;
  onAssignGroup: (m: Machine) => void;
  onDecommission: (m: Machine) => void;
  onRestore: (m: Machine) => void;
}

export const buildFleetActions = (
  machine: Machine,
  canWrite: boolean,
  h: FleetActionHandlers
): FleetMenuAction[] => {
  if (machine.isDecommissioned) {
    const restoreOnly: FleetMenuAction[] = [
      { id: "qr", labelKey: "myMachinery:qrCode", onSelect: () => h.onQrCode(machine) },
    ];
    if (canWrite) {
      restoreOnly.push({
        id: "restore",
        labelKey: "myMachinery:restore",
        onSelect: () => h.onRestore(machine),
      });
    }
    return restoreOnly;
  }

  const actions: FleetMenuAction[] = [
    { id: "profile", labelKey: "myMachinery:profile", onSelect: () => h.onProfile(machine) },
    { id: "qr", labelKey: "myMachinery:qrCode", onSelect: () => h.onQrCode(machine) },
    {
      id: "sr",
      labelKey: "myMachinery:createServiceReport",
      onSelect: () => h.onCreateServiceReport(machine),
    },
  ];

  if (!canWrite) return actions;

  actions.push(
    {
      id: "rfs",
      labelKey: "myMachinery:createServiceRequest",
      onSelect: () => h.onCreateServiceRequest(machine),
    },
    {
      id: "edit",
      labelKey: "myMachinery:editDetails",
      onSelect: () => h.onEditDetails(machine),
    },
    {
      id: "duplicate",
      labelKey: "myMachinery:duplicate",
      onSelect: () => h.onDuplicate(machine),
    },
    {
      id: "group",
      labelKey: "myMachinery:assignToGroup",
      onSelect: () => h.onAssignGroup(machine),
    },
    {
      id: "decommission",
      labelKey: "myMachinery:decommission",
      onSelect: () => h.onDecommission(machine),
      danger: true,
    }
  );

  return actions;
};

export default buildFleetActions;
